import type { HTMLAttributes, ReactElement } from 'react';

import classNames from 'classnames';

import styles from './Mask.module.css';

export type MaskSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type MaskShape = 'circle' | 'squircle';

export interface MaskProps extends HTMLAttributes<HTMLElement> {
  /** Shape that the image should take */
  shape: MaskShape;
  /** Size variant of the mask */
  size: MaskSize;
  /** A single element */
  children: ReactElement;
  className?: string;
}
/**
 * Mask a single element to the shape of a circle or "squircle".
 *
 * @see https://corgi-x.tfd.engineering/components/mask
 */
export function Mask({
  children,
  shape,
  size,
  className,
  ...props
}: MaskProps) {
  return (
    <div
      className={classNames(styles[shape], styles[size], className)}
      {...props}
    >
      {children}
    </div>
  );
}
